<div class="table-responsive">
  <table class="table table-sm table-striped align-middle">
    <thead>
      <tr>
        <th>Acao</th>
        <th>Matricula</th>
        <th>Funcionario</th>
        <th>Data</th>
        <th>Dia</th>
        <th>Primeira batida</th>
        <th>Segunda batida</th>
        <th>Terceira batida</th>
        <th>Quarta batida</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let linha of linhas; trackBy: trackByLinha">
        <td>
          <div class="d-flex gap-1">
            <button type="button" class="btn btn-primary btn-sm" (click)="editarOuSalvar.emit(linha)" [disabled]="!linha.funcionarioId">
              <i class="bi" [ngClass]="linhaEditando === linha.chave ? 'bi-floppy' : 'bi-pencil-square'"></i>
            </button>
            <button
              *ngIf="linhaEditando !== linha.chave"
              type="button"
              class="btn btn-outline-secondary btn-sm"
              [disabled]="!linha.funcionarioId"
              title="Historico de alteracoes"
              (click)="verHistorico.emit(linha)">
              <i class="bi bi-clock-history"></i>
            </button>
            <button *ngIf="linhaEditando === linha.chave" type="button" class="btn btn-outline-secondary btn-sm" (click)="cancelarEdicao.emit()">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </td>
        <td>{{ linha.matricula }}</td>
        <td>{{ linha.nome }}</td>
        <td>{{ linha.data }}</td>
        <td class="fw-semibold">{{ linha.diaSemana }}</td>
        <td>
          <input *ngIf="linhaEditando === linha.chave" class="form-control form-control-sm" type="time" [(ngModel)]="batidasEdicao[0]" (ngModelChange)="batidasEdicaoChange.emit(batidasEdicao)">
          <span *ngIf="linhaEditando !== linha.chave">{{ linha.batidas[0] || '-' }}</span>
        </td>
        <td>
          <input *ngIf="linhaEditando === linha.chave" class="form-control form-control-sm" type="time" [(ngModel)]="batidasEdicao[1]" (ngModelChange)="batidasEdicaoChange.emit(batidasEdicao)">
          <span *ngIf="linhaEditando !== linha.chave">{{ linha.batidas[1] || '-' }}</span>
        </td>
        <td>
          <input *ngIf="linhaEditando === linha.chave" class="form-control form-control-sm" type="time" [(ngModel)]="batidasEdicao[2]" (ngModelChange)="batidasEdicaoChange.emit(batidasEdicao)">
          <span *ngIf="linhaEditando !== linha.chave">{{ linha.batidas[2] || '-' }}</span>
        </td>
        <td>
          <input *ngIf="linhaEditando === linha.chave" class="form-control form-control-sm" type="time" [(ngModel)]="batidasEdicao[3]" (ngModelChange)="batidasEdicaoChange.emit(batidasEdicao)">
          <span *ngIf="linhaEditando !== linha.chave">{{ linha.batidas[3] || '-' }}</span>
        </td>
      </tr>
      <tr *ngIf="linhas.length === 0">
        <td colspan="9" class="text-secondary">Nenhum registro no periodo selecionado.</td>
      </tr>
    </tbody>
  </table>
</div>
